import React from "react"

interface FallbackProps {
  error: Error
  resetError: () => void
}

export const ErrorFallback: React.FC<FallbackProps> = ({
  error,
  resetError,
}) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        width: "100vw",
        backgroundColor: "#121212",
        color: "white",
        fontFamily: "sans-serif",
        textAlign: "center",
        padding: "2rem",
      }}
    >
      <h1 style={{ marginBottom: "1rem", color: "#ff6b6b" }}>
        System Interruption
      </h1>
      <p style={{ marginBottom: "2rem", maxWidth: "600px", opacity: 0.8 }}>
        The application encountered an unexpected error. The system
        administrator has been notified.
      </p>

      {/* Optionally render the error message for debugging if needed, but usually hidden in kiosks */}
      <pre
        style={{
          background: "rgba(255,255,255,0.05)",
          padding: "1rem",
          borderRadius: "8px",
          color: "#ffc9c9",
          maxWidth: "80%",
          overflow: "auto",
          fontSize: "0.8rem",
          marginBottom: "2rem",
          textAlign: "left",
        }}
      >
        {error.message}
      </pre>

      <button
        onClick={resetError}
        style={{
          padding: "1rem 2rem",
          fontSize: "1.2rem",
          backgroundColor: "white",
          color: "black",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer",
          fontWeight: "bold",
        }}
      >
        Restart Experience
      </button>
    </div>
  )
}
